module.exports = __webpack_public_path__ + "static/pic01-8bf95f50cf15d59c77530dbd2b5e3e58.jpg";